module.exports = __webpack_public_path__ + "img/promotion-boost-plus.03cb9ccc.svg";